export { default } from './ResponsiveImage.vue';
